import useRouter from "hooks/useRouter";
import { useEffect, useMemo } from "react";
import _ from "lodash";
import CoinvestorReconciliationDetailView from "../../components/CoinvestorReconciliationDetailView";
import SaleReconciliationDetailView from "features/ReconciliationReport/SaleReconciliationReport/components/SaleReconciliationDetailView";
import Utils from "general/utils/Utils";

CoinvestorReconciliationDetailScreen.propTypes = {};

function CoinvestorReconciliationDetailScreen(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();
    const hash = router?.location?.hash;
    const { parent, child } = useMemo(() => Utils.parseHash(hash), [hash]);

    const isCoinvestorTab = parent === 'coinvestor-reconciliation';
    const isSaleTab = parent === 'sale-reconciliation';

    return (
        <div>
            {isCoinvestorTab ? (
                <CoinvestorReconciliationDetailView activeChildTab={child} />
            ) : isSaleTab ? (
                <SaleReconciliationDetailView primaryRole="INVESTOR" activeChildTab={child} />
            ) : (
                <></>
            )}
        </div>
    );
}

export default CoinvestorReconciliationDetailScreen;
